export default __webpack_public_path__ + "static/media/github_logo.0c1c229f.png";